const baseStyleTrack = {
  borderRadius: "full",
  p: "2px",
  width: "2.875rem",
  height: "1.5rem",
  transitionProperty: "common",
  transitionDuration: "fast",
  bg: "lowEmphasis",
  _focusVisible: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  _checked: {
    bg: "primaryLight"
  }
};

const baseStyleThumb = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: "1.5rem",
  height: "1.5rem",
  _checked: {
    transform: `translateX(1.375rem)`,
    bg: "primary"
  }
};

const baseStyle = {
  track: baseStyleTrack,
  thumb: baseStyleThumb
};

export default {
  baseStyle
};
